import styled from 'styled-components'
import { Box } from '../../UI/Box'
import { IPool } from '../../../types/reducerTypes'

export const BadgeGroup = styled(Box)`
  a {
    display: inline-flex;
  }
`

export const Badge = styled(Box)<{ color: string }>`
  background-color: ${({ color }) => color};

  display: inline-flex;
  padding: 4px 10px;
  align-items: flex-start;
  gap: 10px;

  border-radius: 4px;

  color: ${({ theme }) => theme.colors.brandPrimaryText};
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px; /* 109.091% */
  text-transform: uppercase;
`

function PoolBadges({
  audit,
  clientVerifications,
}: Pick<IPool, 'audit' | 'clientVerifications'>) {
  const hasAudit = !!audit?.url && audit?.status === 'complete'
  const hasKyc = clientVerifications?.kyc?.status === 'complete'
  const hasDoxx = clientVerifications?.doxx?.status === 'complete'

  if (!hasAudit && !hasKyc && !hasDoxx) return null

  return (
    <BadgeGroup ac g={12} aw fw>
      {hasAudit && (
        <a
          href={audit?.url}
          target="_blank"
          rel="noreferrer"
          title="View audit report"
          onClick={(e) => e.stopPropagation()}
        >
          <Badge color="#508AA8">AUDIT</Badge>
        </a>
      )}
      {hasKyc && (
        <a
          href="https://zap-launchpad.notion.site/KYC-Verification-Completed-e42aa509e7194628ac8bd73e770d23ca?pvs=4"
          target="_blank"
          rel="noreferrer"
          title="View KYC"
          onClick={(e) => e.stopPropagation()}
        >
          <Badge color="#00FFA3">KYC</Badge>
        </a>
      )}
      {hasDoxx && (
        <a
          href={clientVerifications?.doxx?.url}
          target="_blank"
          rel="noreferrer"
          title="View DOXX"
          onClick={(e) => e.stopPropagation()}
        >
          <Badge color="#BBF6E2">DOXX</Badge>
        </a>
      )}
    </BadgeGroup>
  )
}

export default PoolBadges
